import React from "react";
import Checkbox_not_selected from "../../assets/images/icons/Checkbox-not-selected.svg";
import Checkbox_selected from "../../assets/images/icons/Checkbox-selected.svg";
import drug_img from "../../assets/images/DrugDefault.png";
import { useTranslation } from "react-i18next";
import { IDrug } from "../../interface/GeneralResponse";
import { AppConfig } from "../../api/config/config";
import { getDrugDisplayName } from "./utils";

interface AddPrescriptionSearchDrugCardProps {
  drug: IDrug;
  onSelect: (drug: IDrug) => void;
  isSelected: boolean;
}

const AddPrescriptionSearchDrugCard: React.FC<
  AddPrescriptionSearchDrugCardProps
> = ({ drug, onSelect, isSelected }) => {
  const { t } = useTranslation();

  const handleClick = () => {
    onSelect(drug);
  };


  return (
    <div
      className={`flex w-full cursor-pointer justify-between rounded-lg px-4 py-3 duration-300 ${isSelected ? "border-primary bg-blue-50" : "bg-white"
        } hover:bg-primary-bg`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      }}
      aria-pressed={isSelected}
      aria-label={`${drug.DrugName} ${drug.PackageName} ${isSelected ? t("selected") : t("select_drug")
        }`}
    >
      <div className="flex w-full items-center gap-3">
        <img
          src={isSelected ? Checkbox_selected : Checkbox_not_selected}
          alt={isSelected ? "Selected" : "Save"}
          className="h-5 w-5"
        />
        <img
          src={drug.Image ? `${AppConfig.SERVER_URL}${drug.Image}` : drug_img}
          alt={drug.DrugName}
          className="h-14 w-14 rounded-lg object-cover"
        />
        <div className="flex flex-col justify-center">
          <h3 className={`font-bold ${isSelected ? "text-primary" : ""}`}>
            {getDrugDisplayName(drug)} {drug.PackageName}
          </h3>
          {drug?.DosageFormName && <div className="text-body-text flex items-center gap-2">
            <p className="text-sm font-semibold">
              {drug.PublicPrice + " " + drug.CurrencyName}
            </p>
            <span>.</span>
            <p className="text-sm">{drug.DosageFormName}</p>
          </div>}
          <p className="text-primary-textFont text-xs">{drug?.FacilityName}</p>
        </div>
      </div>
    </div>
  );
};

export default AddPrescriptionSearchDrugCard;
